<template>
  <aicc-page  :titleShow="false" style="overflow:hidden;">    
    <ur-area>
      <div class="pop_header">
        <p class="pop_title" style="margin-top:40px;">시나리오 만들기</p>
      </div>
      <div class="pop_body">
        <div class="tbl_write">
          <table>
            <caption>시나리오 만들기</caption>
            <colgroup>
              <col style="width:166px">
              <col style="width:auto">
            </colgroup>
            <tbody>
              <!-- 시나리오 구분 -->
              <tr>
                <th scope="row" class="vm">시나리오 구분<span class="essential">*</span></th>
                <td>
                  <ur-segment-wrapper primary v-model="scenarioType">
                    <ur-segment-button large value="standard">
                      <strong>표준 시나리오</strong>
                      <span>선택한 타입의 표준 시나리오가 바로 생성됩니다.</span>
                    </ur-segment-button>
                    <ur-segment-button large value="new">
                      <strong>신규 시나리오</strong>
                      <span>담당 큐레이터가 맞춤형 시나리오를 설계해 드립니다. </span>
                      <em>* 별도 비용 발생 </em>
                    </ur-segment-button>
                  </ur-segment-wrapper>
                </td>
              </tr>
              <!-- 표준 시나리오 -->
              <tr v-if="isStandard()">
                <td colspan="2">                       
                  <standard ref="standard" :parentPageId="contextPageId" :scenarioNameItems="scenarioNameItems" @complete="closeAndRefresh()" style="height:600px;"/>                      
                </td>
              </tr>
              <!-- 신규 시나리오 -->
              <tr  v-else>                
                <td colspan="2">   
                  <new ref="new" :parentPageId="contextPageId" :scenarioNameItems="scenarioNameItems" @complete="closeAndRefresh()" style="height:600px;"/>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>    
      <div style="float:right">
        <ur-button primary @click="close()">취소</ur-button>  
        <ur-button shape="solid" primary @click="onClickAddScenario()">완료</ur-button>
      </div>
    </ur-area>
  </aicc-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';
import CMP_AID_00003 from '../../components/CMP_AID_00003';
import CMP_AID_00004 from '../../components/CMP_AID_00004';

export default {
  name: 'PGE_AID_00003', // eslint-disable-line vue/name-property-casing
  components: {
    standard: CMP_AID_00003,
    new: CMP_AID_00004,
  },
  extends: BasePage,
  data() {
    return {
      scenarioType: 'standard',
      
      // 기존 시나리오 이름
      scenarioNameItems: [],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      this.getScenarioNameItems();
    },
    isStandard() {
      return this.scenarioType === 'standard';
    },

    // 기존 시나리오 이름 조회
    getScenarioNameItems() {
      http.request(this.contextPageId, 'DTS_AID_00001', {
        data: {},
      }).then(res => {
        for (var item in res.data.scenarioList) {
          this.scenarioNameItems.push(res.data.scenarioList[item].scenarioName);
        }
      });
    },

    // 시나리오 만들기 완료
    onClickAddScenario() {
      if (this.isStandard()) {
        this.$refs.standard.request();
      } else {
        this.$refs.new.request();
      }
    },
    closeAndRefresh() { // 시나리오 만들기 완료시 시나리오 리스트 갱신하록 flag 변경
      window.opener.parent.setRefreshEnabled();
      window.close();
    },

    // 시나리오 만들기 취소
    close() {
      window.close();
    },
  },
};
</script>

<style scoped>
.tbl_write th{
  text-align:left;
}
.tbl_write td{
  padding : 16px 16px 16px 0;
}
</style>
